<script setup>
import state from "./state";
import {computed, onMounted, ref, toRef} from "vue";
import ParticipantEntry from "../components/ParticipantEntry.vue";
import SchemaCollection from "../../components/SchemaCollection";

const currentParticipant = ref({});

onMounted(() => {
  if (state.value.participants.length > 0) {
    currentParticipant.value = state.value.participants[0];
  }
})

const participants = computed({
  get(){
    return state.value.participants;
  },

  set(participants){
    state.value.participants = participants;
  }
})

const currentParticipantIndex = computed({
  get() {
    return participants.value.indexOf(currentParticipant.value);
  },

  set(index) {
    if(index === -2){
      index = participants.value.length - 1;
    }
    currentParticipant.value = participants.value[index];
  }
})


const isEditingExistent = computed(() => currentParticipantIndex.value !== -1)

function addNewParticipant() {
  currentParticipant.value = {
    address: {},
  };
  participants.value.push(currentParticipant.value);
}

function removeParticipant(index) {
  participants.value.splice(index, 1);

  if (participants.value.length <= 0) {
    addNewParticipant();
  }
}

function previousParticipant() {
  console.log('previous participant', isCurrentParticipantValid, isCurrentParticipantValid.value);
  if (!isCurrentParticipantValid.value) {
    console.log('niet valid');
    participants.value.splice(currentParticipantIndex.value, 1);
  }
  console.log('terug');
  currentParticipantIndex.value--;
}

const isCurrentParticipantValid = computed( () => {
  return SchemaCollection.participant.isValidSync(currentParticipant.value);
})

</script>

<template>
<div>
  <div class="form__title">
    <h2>
      De cursist(en)
    </h2>
  </div>

  <ul class="participant-list">
    <li
        v-for="(participant, index) in participants"
        :class="participant === currentParticipant ? 'participant--highlight' : '' "
        v-show="participant.firstName"
    >
      <span>{{ index + 1 }}</span> {{ participant.firstName }}{{ participant.prefix ? ' '+participant.prefix+' ' : ' ' }}{{ participant.lastName }}
    </li>
  </ul>

  <ParticipantEntry v-model="currentParticipant"/>

  <div class="participant-buttons">
    <button class="button button--padding button--blue"
            @click="previousParticipant()" v-if="currentParticipantIndex > 0 || (!isEditingExistent && participants.length > 0)"
    >
      Vorige cursist
    </button>

    <button class="button button--padding button--blue"
            @click="addNewParticipant()"
            :disabled="!isCurrentParticipantValid">
      + extra cursist toevoegen
    </button>

    <button class="button button--padding button--blue"
            @click="currentParticipantIndex++" v-if="isEditingExistent && currentParticipantIndex < participants.length - 1"
            :disabled="!isCurrentParticipantValid">
      Volgende cursist
    </button>
  </div>

  <div class="participant-list-wrapper" v-if="participants.length > 1">
    <h2 class="participant-list-wrapper__title">Toegevoegde cursisten</h2>
    <ul class="participant-list">
      <li
          v-for="(participant, index) in participants"
          :class="participant === currentParticipant ? 'participant--highlight' : '' "
          v-show="participant.firstName"
      >
        <span class="name">
          <span class="number">{{ index + 1 }}</span> {{ participant.firstName }}{{ participant.prefix ? ' '+participant.prefix+' ' : ' ' }}{{ participant.lastName }}
        </span>
        <button
            @click="removeParticipant(index)"
            class="button button--grey"
        >
              Verwijder cursist
        </button>
      </li>
    </ul>
  </div>

  <div class="courseflow-nextbtn">
    <component :to="{name: 'invoice'}"
               class="button button--green"
               :class="{'button--disabled': !isCurrentParticipantValid}"
               :is="isCurrentParticipantValid ? 'router-link' : 'span'">
      <div class="button__text">
        Factuur
      </div>
    </component>
  </div>

</div>
</template>